import { MEDIA_ARTICLE, MEDIA_NOTATION, MEDIA_QUESTIONBOX, MEDIA_QUIZZ, MEDIA_SURVEY } from "../constants.js";
import { ArticleDto, NotationEventDto, QuestionBoxEventDto, QuizzEventDto, SurveyEventDto } from "../MatchEventDTO.js";
import { GameFactEventFactory } from "./GameFactEventFactory.js";

export class MatchEventFactory {
    static create(event) {
        if(event.type === MEDIA_SURVEY)
          return new SurveyEventDto(event);
        else if(event.type === MEDIA_QUIZZ)
          return new QuizzEventDto(event);
        else if(event.type === MEDIA_QUESTIONBOX)
          return new QuestionBoxEventDto(event);
        else if(event.type === MEDIA_ARTICLE)
          return new ArticleDto(event)
        else if(event.type === MEDIA_NOTATION)
          return new NotationEventDto(event)
        else
          return GameFactEventFactory.create(event);
    }
  }